import { Box, Paper, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

/**
 * Reads `status` from the current URL's query string. If `status=error`
 * is present, the failure state is shown; otherwise the success state
 * is shown (per spec, success has no query parameters at all).
 */
export default function PaymentStatusPage() {
  const params = new URLSearchParams(window.location.search);
  const isError = params.get("status") === "error";

  const handleBackToLogin = () => {
    window.location.href = "/login";
  };

  const handleTryAgain = () => {
    window.history.back();
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: { xs: "40px 16px", md: "60px 32px" },
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          width: "100%",
          maxWidth: 480,
          p: { xs: 3, md: 4 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        {isError ? (
          <CancelIcon sx={{ fontSize: 72, color: "error.main", mb: 2 }} />
        ) : (
          <CheckCircleIcon sx={{ fontSize: 72, color: "success.main", mb: 2 }} />
        )}

        <Typography variant="h5" fontWeight={700} sx={{ mb: 1.5 }}>
          {isError ? "Payment Failed" : "Payment Successful"}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          {isError
            ? "Your payment could not be completed. Please try the payment process again."
            : "Your payment has been completed successfully. Please check your email. You will receive your login credentials (User ID and Password) there to access your account."}
        </Typography>

        {isError ? (
          <Typography
            variant="body2"
            color="primary"
            fontWeight={600}
            onClick={handleTryAgain}
            sx={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Please try again.
          </Typography>
        ) : (
          <Button variant="contained" color="primary" size="large" fullWidth onClick={handleBackToLogin}>
            Back to Login
          </Button>
        )}
      </Paper>
    </Box>
  );
}